import {Component, Input, OnInit} from '@angular/core';
import {durationToStr, TransportIntervention, TransportInterventionPoi, TransportInterventionPoiGroupReport} from 'shared';

@Component({
  selector: 'app-transport-interventions-metrics-charts',
  templateUrl: './transport-interventions-metrics-charts.component.html',
  styleUrls: ['./transport-interventions-metrics-charts.component.scss']
})
export class TransportInterventionsMetricsChartsComponent implements OnInit {
  @Input()
  intervention: TransportIntervention;

  @Input()
  poiList: TransportInterventionPoi[];

  report: any[];

  @Input()
  set poiListGroupReport(report: TransportInterventionPoiGroupReport[]) {
    if (!report) {
      return;
    }
    this.report = report.map((item) => {
      return {
        name: item.poi.name,
        length_in_km: item.metrics.length_in_km,
        visit_duration: item.visit_duration,
        fuel_total_consumption: item.metrics.fuel_total_consumption,
        engine_working_time: item.metrics.engine_working_hours,
      };
    });
  }

  charts;
  current: any;

  constructor() {
  }

  ngOnInit(): void {
    this.charts = [{
      title: 'Distance',
      field: 'length_in_km',
      customizeText: (arg) => {
        return arg.value.toFixed(2) + ' km';
      }
    }, {
      title: 'Temps d\'Arrêt',
      field: 'visit_duration',
      customizeText: (arg) => {
        return durationToStr(arg.value, true);
      }
    }, {
      title: 'Consomation Carburant',
      field: 'fuel_total_consumption',
      customizeText: (arg) => {
        return arg.value.toFixed(2) + ' L';
      }
    }, {
      title: 'Heures Moteurs',
      field: 'engine_working_hours',
      customizeText: (arg) => {
        return (arg.value / 3600).toFixed(2) + ' h';
      }
    }];
    this.current = this.charts[0];
  }

  onValueChanged(e: any) {
    this.current = e.value;
  }
}
